export default __webpack_public_path__ + "static/media/sticker-photo-challenge.393969ce.png";